/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextBtn from "./TextBtn";
import BaseComponent from "../../../../base/BaseComponent";
import {message} from "antd";
import request from "../../../../base/request";
export default class OneClickBtn extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    sysConfigLoadOver() {

       this.setState()
    }
  getBtn(){
      return ( <TextBtn btnClick={()=>{
          this.btnClick(this.props.record)
      }} btnText={this.props.btnText} />)
    }

    customRender() {
        let btn = this.getBtn();
        console.log(btn)
        return (
            <div> {btn}</div>

        )
    }
   btnClick(record){

       let btn=this.props.btn||'';


       let body = {};
       let url = btn && btn.requestUrl ||"";
       let joinParam = btn && btn.joinParam ||"";
       let method = btn && btn.requestMethod ||"post";
       let contentType = btn && btn.contentType ||"json";
       let statusParam = btn && btn.statusParam ||"";
       let statusKey = btn && btn.statusKey ||"";
       let messageText = btn && btn.messageText ||"发布成功";
       let errorText = btn && btn.errorText ||"发布失败";
       if(!url) return message.warning('配置接口出错,请检查')
       if(url){
           //封装参数
           if(joinParam) {
               url += record[joinParam]
           }
           body[statusParam] = statusKey
           request({url,method,contentType,body,callBack:(data)=>{
                   if(data) {
                       message.info(messageText)
                       this.props.refresh&&this.props.refresh()
                   }else{
                       message.info(errorText)
                   }
               }})
       }

   }

   //导出方法
    exportFile(){
        console.log('导出----------')
    }

}